import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    deadline: null,
    generalIndex: 0.0,
    values: [],
    rentHealth: 0.0,
    staffHealth: 0.0,
    materialHealth: 0.0,
    taxesHealth: 0.0,
    debtsHealth: 0.0,
    otherHealth: 0.0
  }
});
